import { cardTokens } from '../../styles/cardTokens';

// Mirrors ContentDetailLayout + GuideDetailHero / BonusDetailHero sizes so the swap to content does not jump
const Bar = ({ className = '' }) => <div className={`bg-gray-200 dark:bg-gray-700 rounded ${className}`} />;

const ArticleBodySkeleton = () => (
  <div className="rounded-2xl border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 p-4 md:p-6 space-y-3">
    <Bar className="h-4 w-full" />
    <Bar className="h-4 w-full" />
    <Bar className="h-4 w-5/6" />
    <Bar className="h-4 w-full" />
    <Bar className="h-4 w-2/3" />
    <Bar className="h-6 w-1/2 !mt-6" />
    <Bar className="h-4 w-full" />
    <Bar className="h-4 w-full" />
    <Bar className="h-4 w-4/5" />
  </div>
);

const ContentDetailSkeleton = ({ variant = 'guide' }) => (
  <div className="container-narrow page-y-detail">
    <div className="animate-pulse">
      <div className="mb-6 h-6 flex items-center">
        <Bar className="h-4 w-40" />
      </div>

      {variant === 'bonus' ? (
        <div className="space-y-4">
          <div className={`${cardTokens.shell} p-4 md:p-5`}>
            <div className="flex items-center gap-3">
              <Bar className="w-10 h-10 rounded-lg flex-shrink-0" />
              <div className="flex-1 space-y-1.5">
                <Bar className="h-4 w-20" />
                <Bar className="h-3 w-36" />
              </div>
            </div>
            <div className="mt-3 space-y-1.5">
              <Bar className="h-6 w-full" />
              <Bar className="h-6 w-3/4 md:hidden" />
            </div>
            <Bar className="mt-3 h-8 md:h-9 w-56" />
            <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:gap-3">
              <Bar className="h-12 w-full sm:flex-1 rounded-xl" />
              <Bar className="h-12 w-full sm:flex-1 rounded-xl" />
            </div>
          </div>

          <ArticleBodySkeleton />
        </div>
      ) : (
        <div className="space-y-4">
          <div className={`${cardTokens.shell} overflow-hidden`}>
            <div className="h-48 md:h-56 bg-gray-200 dark:bg-gray-700" />
            <div className="p-4 md:p-6">
              <div className="flex flex-wrap items-center gap-3 mb-4">
                <Bar className="h-6 w-28 rounded-xl" />
                <Bar className="h-4 w-16" />
                <Bar className="h-4 w-36" />
                <Bar className="h-4 w-16" />
              </div>
              <div className="space-y-1.5 mb-3">
                <Bar className="h-7 md:h-9 w-full" />
                <Bar className="h-7 w-2/3 md:hidden" />
              </div>
              <div className="space-y-2 mb-4">
                <Bar className="h-4 md:h-5 w-full" />
                <Bar className="h-4 md:h-5 w-full" />
                <Bar className="h-4 w-full md:hidden" />
                <Bar className="h-4 w-1/2 md:hidden" />
              </div>
              <Bar className="h-6 w-20 rounded-xl" />
            </div>
          </div>

          <ArticleBodySkeleton />
        </div>
      )}
    </div>
  </div>
);

export default ContentDetailSkeleton;
